<div
  class="content-product-carousel"
  *ngIf="storyBlokProducts?.length"
  (widthChanged)="onWidthChanged($event)"
  [appDynamicSize]="!isMobile"
  [ngStyle]="{
    paddingLeft: isContentLandingPage ? '0px' : null
  }"
>
  <h3
    *ngIf="title"
    class="content-product-carousel__title"
    [ngStyle]="{
      paddingLeft: isContentLandingPage ? '0px' : null
    }"
  >
    {{ title }}
  </h3>
  <div
    [ngClass]="{
      'content-product-carousel__container': hasTeaser()
    }"
  >
    <app-teaser
      *ngIf="hasTeaser() && checkIfHasMoreThanFiveProducts(storyBlokProducts)"
      [ngStyle]="{
        width: isMobile ? 'auto' : teaserWidth
      }"
      class="content-product-carousel__container__product-teaser"
      [teaser]="teaser[0]"
      [isMobile]="isMobile"
      [isLongText]="isLongText()"
    ></app-teaser>
    <app-product-carousel
      class="content-product-carousel__container__carousel"
      [isMobile]="isMobile"
      [isDesktop]="!isMobile"
      [products]="storyBlokProducts"
      (productClicked)="onProductClick($event.product, $event.priceType, $event.index)"
      (productCarouselPrev)="onProductCarouselNavigation(DIRECTION.LEFT)"
      (productCarouselNext)="onProductCarouselNavigation(DIRECTION.RIGHT)"
      (swipeLeft)="onProductCarouselSwipe(DIRECTION.LEFT)"
      (swipeRight)="onProductCarouselSwipe(DIRECTION.RIGHT)"
    >
    </app-product-carousel>
  </div>
</div>
